// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema).
import {z} from 'zod';

export const RecordSchema = z.object({
    priceId: z.string().min(1, 'Required'),
    quantity: z.number({invalid_type_error: 'Required'}).min(1, 'Quantity must be at least 1'),
});
